import type { RouteRecordRaw } from 'vue-router'
import { PermissionAction, PermissionResource } from '@nailsupply/review-swagger/auth'
import { allFeatureFlagRoutes } from '@/pages/feature-flags/routes'

export const featureFlagRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
    permission: { resource: PermissionResource.enum.feature_flag, action: PermissionAction.enum.view },
  },
  children: [
    ...allFeatureFlagRoutes,
  ],
}
